import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-58">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-59">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-60">
          <div className="col-span-1 md:col-span-2" data-id="element-61">
            <div className="flex items-center gap-2 mb-4" data-id="element-62">
              <div className="flex h-8 w-8 items-center justify-center rounded bg-blue-600 text-white font-bold text-lg" data-id="element-63">
                A
              </div>
              <span className="text-xl font-bold text-white" data-id="element-64">
                AMK<span className="text-blue-500" data-id="element-65">Solutions</span>
              </span>
            </div>
            <p className="max-w-xs text-sm leading-relaxed" data-id="element-66">
              Professional customer support outsourcing services tailored to
              help your business grow and succeed.
            </p>
          </div>

          <div data-id="element-67">
            <h3 className="text-white font-semibold mb-4" data-id="element-68">Services</h3>
            <ul className="space-y-2 text-sm" data-id="element-69">
              <li data-id="element-70">
                <a href="#services" className="hover:text-blue-400 transition-colors" data-id="element-71">
                  Email & Chat Support
                </a>
              </li>
              <li data-id="element-72">
                <a href="#services" className="hover:text-blue-400 transition-colors" data-id="element-73">
                  Phone Support
                </a>
              </li>
              <li data-id="element-74">
                <a href="#services" className="hover:text-blue-400 transition-colors" data-id="element-75">
                  eCommerce Support
                </a>
              </li>
              <li data-id="element-76">
                <a href="#services" className="hover:text-blue-400 transition-colors" data-id="element-77">
                  Back-Office
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-78">
            <h3 className="text-white font-semibold mb-4" data-id="element-79">Company</h3>
            <ul className="space-y-2 text-sm" data-id="element-80">
              <li data-id="element-81">
                <a href="#about" className="hover:text-blue-400 transition-colors" data-id="element-82">
                  About Us
                </a>
              </li>
              <li data-id="element-83">
                <a href="#why-us" className="hover:text-blue-400 transition-colors" data-id="element-84">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-85">
                <a href="#industries" className="hover:text-blue-400 transition-colors" data-id="element-86">
                  Industries
                </a>
              </li>
              <li data-id="element-87">
                <a href="#contact" className="hover:text-blue-400 transition-colors" data-id="element-88">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-89">
          <p data-id="element-90">
            &copy; {new Date().getFullYear()} AMK Solutions. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-91">
            <a href="#" className="hover:text-white transition-colors" data-id="element-92">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-93">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}